import { Component, OnInit } from '@angular/core';
import {faBoxUsd, faEnvelope, faFileInvoiceDollar, faMoneyCheckAlt, faSuitcase, faTruck} from 'src/app/icons/light';
import data from 'src/data';

@Component({
    selector: 'app-inicio-beneficios',
    templateUrl: './inicio-beneficios.component.html',
    styleUrls: ['./inicio-beneficios.component.scss'],
    standalone: false
})
export class InicioBeneficiosComponent implements OnInit {
  public showModal = false;
  public elaboraGuia = data.sitios;
  public icons = {
    boxUsd: faBoxUsd,
    invoice: faFileInvoiceDollar,
    envelope: faEnvelope,
    suitcase: faSuitcase,
    money: faMoneyCheckAlt,
    truck: faTruck
  };

  ngOnInit() { }

  hideModal() {
    this.showModal = false;
  }
}
